import React, { useEffect, useState } from 'react';
import './App.css';
import { Button, FormControl, InputLabel, Input } from '@material-ui/core'
import Message from './Message';
import FlipMove from 'react-flip-move'
import SendIcon from '@material-ui/icons/Send'
import IconButton from '@material-ui/core/IconButton'

import axios from './axios'
import Pusher from 'pusher-js'

const pusher = new Pusher('29566954f7637744fecc', {
  cluster: 'ap1'
})

function App() {
  const [input, setInput] = useState('')
  const [messages, setMessages] = useState([])
  const [username, setUsername] = useState('')


  const sync = async () => {
    await axios.get('/retrieve/conversation')
      .then((res) => {
        console.log(res.data)
        setMessages(res.data)
      })
  }

  /*useEffect(() => {
    sync()
  }, [])*/

  useEffect(() => {
    const channel = pusher.subscribe('messages')
    channel.bind('newMessage', function (data) {
      sync()
    })
  }, [username])

  useEffect(() => {
    setUsername(prompt('Please enter your name'))
  }, [])

  const sendMessage = (e) => {
    e.preventDefault()

    axios.post('/save/messages', {
      username: username,
      message: input,
      timestamp: Date.now()
    })

    setInput('')
  }

  return (
    <div className="App">
      <div className='app__header'>
        <img src="https://www.canva.com/design/DAEJ-SywJvQ/brAptxGADI6bWUmR_5I4RA/view?utm_content=DAEJ-SywJvQ&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink" alt="3bujang logo" className="app__logo" />
        <h2>Welcome {username}</h2>
      </div>

      <FlipMove className="app__chat">
        {
          messages.map(message => (
            <Message key={message._id} message={message} username={username} />
          ))
        }
      </FlipMove>

      <form className='app__form' >
        <FormControl className='app__formControl' >
          <Input className='app__input' placeholder='Enter a message...' value={input} onChange={(e) => setInput(e.target.value)} />
          <IconButton className='app__iconButton' variant='text' color='primary' disabled={!input} onClick={sendMessage} type="submit" >
            <SendIcon />
          </IconButton>
        </FormControl>
      </form>
    </div>
  );
}

export default App;
